import { useContext, ReactNode } from 'react';
import {
  DEFAULT_SIDEBAR_WIDTH,
} from '../../sharedComponents/TextEditor/constants';
import { SidebarContext } from '../../sharedComponents/TextEditor/context/SidebarContextProvider';
import styles from '../../styles/Home.module.css';

function EditorWrapper({ children }: {children: ReactNode}) {
  const sidebarOpen = useContext(SidebarContext);

  const sidebarWidth = sidebarOpen ? DEFAULT_SIDEBAR_WIDTH : 0;
  return (
    <main
      className={styles.main}
      style={{
        alignItems: 'unset',
        marginLeft: sidebarWidth,
        maxHeight: '100vh',
        width: `calc(100% - ${sidebarWidth}px)`,
      }}
    >
      {children}
    </main>
  );
}

export default EditorWrapper;
